import { QwickSpark } from "@gigpro/ui/Icons";
import { cn } from "@gigpro/ui/tailwind/cn";
import { LoaderSpinner } from "components/Loader/spinner";
import type React from "react";

const NAME = "QUINCY";

/** With `onOpen`, the Quincy rail that widens into the chat; without, the plain dock's placeholder. One wrapper either way, so the panel survives the swap. */
export const QuincyShell = ({
  open,
  onOpen,
  children,
}: React.PropsWithChildren<{ open: boolean; onOpen?: () => void }>) => (
  <>
    <div
      aria-hidden
      className={cn(
        "w-0 shrink-0 transition-all duration-300 ease-out",
        !onOpen && "hidden md:block",
        onOpen && "w-10",
        open && "w-84",
      )}
    />
    <div
      data-chat-dock={open ? "open" : onOpen && "rail"}
      className={cn(
        onOpen
          ? "fixed top-nav-top right-0 bottom-0 z-40 overflow-hidden border-l transition-all duration-300 ease-out"
          : "contents",
        onOpen && (open ? "border-chat-edge bg-chat-ground shadow-chat-dock w-84" : "w-10 border-white/10 bg-black"),
      )}
    >
      {onOpen && (
        <button
          type="button"
          onClick={onOpen}
          aria-label="Ask Quincy"
          aria-expanded={open}
          className={cn(
            "group absolute inset-y-0 right-0 flex w-10 flex-col items-center gap-2 pt-3 transition-opacity duration-200",
            open && "invisible opacity-0",
          )}
        >
          <span className="flex size-7 items-center justify-center rounded-full bg-brand ring-2 ring-white/20 transition-shadow group-hover:ring-white/40">
            <QwickSpark className="size-3.5 text-white" />
          </span>
          <span aria-hidden className="flex flex-col items-center text-extraSmall/tight font-semibold text-white/60">
            {Array.from(NAME, (letter, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <span key={index}>{letter}</span>
            ))}
          </span>
        </button>
      )}
      {onOpen && open && (
        <div className="absolute inset-y-0 right-0 w-84">
          <LoaderSpinner isLoading />
        </div>
      )}
      {children}
    </div>
  </>
);
